import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Language } from '../../../core/models/core.models';
import { NomLanguages } from '../../../core/constants';

@Component({
  selector: 'app-language-pills',
  templateUrl: './language-pills.component.html',
  styleUrls: ['./language-pills.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LanguagePillsComponent implements OnInit {
  @Input() hasDefault: boolean = true;
  @Output() onLanguageChanged = new EventEmitter<Language>();

  /** Active tab value — `NgpTabset` is value-based, so we mirror `language.id` as a string. */
  activeId: string;

  languages: Language[] = [
    {
      name: 'Default',
      id: NomLanguages.DEFAULT,
      code: '',
      rtl: false,
    },
    {
      name: 'English',
      id: NomLanguages.ENGLISH,
      code: 'en',
      rtl: false,
    },
    {
      name: 'Arabic',
      id: NomLanguages.ARABIC,
      code: 'ar',
      rtl: true,
    },
    {
      name: 'Bulgarian',
      id: NomLanguages.BULGARIAN,
      code: 'bg',
      rtl: false,
    },
  ];

  ngOnInit(): void {
    if (!this.hasDefault) {
      this.languages.shift();
    }
    // Mirror the legacy ngbNav default (first item active). ngbNav emitted
    // activeIdChange on init; ngpTabset does not, so emit the initial language
    // ourselves — consumers (e.g. the synopsis dynamic-form) rely on it to know
    // which language's controls to render, otherwise nothing shows on load.
    const initialLanguage = this.languages[0];
    this.activeId = initialLanguage?.id.toString();
    if (initialLanguage) {
      this.onLanguageChanged.emit(initialLanguage);
    }
  }

  onTabChange(value: string | undefined): void {
    if (value == null) {
      return;
    }
    this.activeId = value;
    this.languageChanged(+value);
  }

  languageChanged(languageId: number) {
    // emit the language object
    const language = this.languages.find((lang) => lang.id === languageId);
    this.onLanguageChanged.emit(language);
  }
}
